import Index from "../views/m9377/Index.vue";
import Find from "../views/m9377/Find/Find.vue";
import Login from "../views/m9377/Login/Login.vue";
import Register from "../views/m9377/Register/Register.vue";
import ForumDetail from "../views/m9377/ForumDetail/ForumDetail.vue";

const routes = [
    {
        path: "/index",
        name: "index",
        component: Index,
    },
    {
        path: "/circle/:id",
        name: "circle",
        component: () => import("../views/m9377/Index.vue"),
    },
    {
        path: "/demo", // demo
        name: "demo",
        component: () => import("../views/m9377/Demo/Demo.vue"),
    },
    {
        path: "/find",
        name: "find",
        component: Find,
    },
    {
        path: "/login",
        name: "login",
        component: Login,
        meta: {
            title: "登录",
        }
    },
    {
        path: "/register",
        name: "register",
        component: () => import("../views/m9377/Register/Register.vue"),
        meta: {
            title: "注册",
        }
    },
    {
        path: "/customercenter",
        name: "customercenter",
        component: () =>
            import(
                "../views/m9377/CustomerCenter/CustomerCenter.vue"
            ),
    },
    {
        path: "/forget",
        name: "forget",
        component: () => import("../views/m9377/Forget/Forget.vue"),
        meta: {
            title: "密码重置",
        }
    },
    {
        path: "/changepassword",
        name: "changepassword",
        component: () =>
            import(
                "../views/m9377/ChangePassword/ChangePassword.vue"
            ),
    },
    {
        path: "/editForum/:type/:id",
        name: "editForum",
        component: () =>
            import("../views/m9377/EditForum/EditForum.vue"),
    },
    {
        path: "/forumdetail/:id",
        name: "forumdetail",
        component: ForumDetail,
    },
    {
        path: "/commentedit/:type/:id",
        name: "commentedit",
        component: () =>
            import("../views/m9377/CommentEdit/CommentEdit.vue"),
    },
    {
        path: "/commentlist/:id/:pid",
        name: "commentlist",
        component: () =>
            import("../views/m9377/CommentList/CommentList.vue"),
    },
    {
        path: "/iframeorder",
        name: "iframeorder",
        component: () =>
            import("../views/m9377/IframeOrder/IframeOrder.vue"),
    },
    {
        path: "/gamelist",
        name: "gamelist",
        component: () => import("../views/m9377/GameList/GameList.vue"),
    },
    {
        path: "/gamedetail/:gameid",
        name: "gamedetail",
        component: () =>
            import("../views/m9377/GameDetail/GameDetail.vue"),
    },
    {
        path: "/gameupdatalog/:gameid",
        name: "gameupdatalog",
        component: () =>
            import(
                "../views/m9377/GameUpdataLog/GameUpdataLog.vue"
            ),
    },
    {
        path: "/welfare",
        name: "welfare",
        component: () => import("../views/m9377/Vip/vip.vue"),
    },
    {
        path: "/goodsdetail/:goodsid",
        name: "goodsdetail",
        component: () =>
            import("../views/m9377/GoodsDetail/GoodsDetail.vue"),
    },
    {
        path: "/mine",
        name: "mine",
        component: () => import("../views/m9377/mine/mine.vue"),
    },
    {
        path: "/userinfo",
        name: "userinfo",
        component: () => import("../views/m9377/UserInfo/UserInfo.vue"),
    },
    {
        path: "/treasurechest",
        name: "treasurechest",
        component: () => import("../views/m9377/TreasureChest/TreasureChest.vue"),
    },
    {
        path: "/minerecord",
        name: "minerecord",
        component: () => import("../views/m9377/MineRecord/MineRecord.vue"),
    },
    {
        path: '/minegame',
        name: 'minegame',
        component: () => import('../views/m9377/MineGame/MineGame.vue'),
    },
    {
        path: '/minemember',
        name: 'minemember',
        component: () => import('../views/m9377/MineMember/minemember.vue'),
    },
    {
        path: '/minegift',
        name: 'minegift',
        component: () => import('../views/m9377/MineGift/MineGift.vue'),
    },
    {
        path: '/address',
        name: 'address',
        component: () => import('../views/m9377/Address/Address.vue'),
    },
    {
        path: '/integraldetail',
        name: 'integraldetail',
        component: () => import('../views/m9377/IntegralDetail/IntegralDetail.vue'),
    },
    {
        path: '/drafts',
        name: 'drafts',
        component: () => import('../views/m9377/Drafts/Drafts.vue'),
    },
    {
        path: '/usersafe',
        name: 'usersafe',
        component: () => import('../views/m9377/UserSafe/UserSafe.vue'),
    },
    {
        path: '/paypwd',
        name: 'paypwd',
        component: () => import('../views/m9377/PayPwd/PayPwd.vue'),
    },
    {
        path: '/bindingphone',
        name: 'bindingphone',
        component: () => import('../views/m9377/BindingPhone/BindingPhone.vue'),
    },
    {
        path: '/realname',
        name: 'realname',
        component: () => import('../views/m9377/RealName/RealName.vue'),
        meta: {
            title: "实名认证",
        }
    },
    {
        path: '/switchuser',
        name: 'switchuser',
        component: () => import('../views/m9377/SwitchUser/SwitchUser.vue'),
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/m9377/About/About.vue'),
    },
    {
        path: '/agreement/:type',
        name: 'agreement',
        component: () => import('../views/m9377/Agreement/Agreement.vue'),
    },
    {
        path: '/message',
        name: 'message',
        component: () => import('../views/m9377/Message/Message.vue'),
    },
    {
        path: '/noticedetail/:id',
        name: 'noticedetail',
        component: () => import('../views/m9377/NoticeDetail/NoticeDetail.vue'),
    },
    {
        path: '/search/:type',
        name: 'search',
        component: () => import('../views/m9377/Search/Search.vue'),
    },
    {
        path: '/complaint/:type/:id',
        name: 'complaint',
        component: () => import('../views/m9377/Complaint/Complaint.vue'),
    },
    {
        path: '/uesrdetail',
        name: 'minedetail',
        component: () => import('../views/m9377/MineDetail/MineDetail.vue'),
    },
    {
        path: '/attention/:tid',
        name: 'attention',
        component: () => import('../views/m9377/Attention/Attention.vue'),
    },
    {
        path: '/mineattention',
        name: 'mineattention',
        component: () => import('../views/m9377/MineAttention/MineAttention.vue'),
    },
    {
        path: '/goodsvirtualdetail/:goodsid',
        name: 'goodsvirtualdetail',
        component: () => import('../views/m9377/GoodsVirtualDetail/GoodsVirtualDetail.vue'),
    },
    {
        path: '/minecollection',
        name: 'minecollection',
        component: () => import('../views/m9377/MineCollection/MineCollection.vue'),
    },
    {
        path: '/headdress',
        name: 'headdress',
        component: () => import('../views/m9377/HeadDress/HeadDress.vue'),
    },
    {
        path: '/userdetail',
        name: 'userdetail',
        component: () => import('../views/m9377/UserDetail/userdetail.vue'),
    },
    {
        path: '/sign/:forum_id/:is_bind_role',
        name: 'sign',
        component: () => import('../views/m9377/Sign/Sign.vue'),
    },
    {
        path: '/',
        name: 'game',
        component: () => import("../views/m9377/Game/Game.vue"),
    },
    {
        path: '/iframe-view',
        name: 'iframe-view',
        component: () => import("../views/m9377/IFrame/IFrame.vue"),
    },
    //type1为购买，type2为续费
    {
        path: '/cloudPhoneShop/:type',
        name: 'cloudPhoneShop',
        component: () => import('../views/m9377/CloudPhoneShop/CloudPhoneShop.vue'),
    },
    {
        path: '/wechatpay/:orderId',
        name: 'wechatpay',
        component: () => import('../views/m9377/WechatPay/WechatPay.vue'),
    },
    {
        path: '/getQrCodeInfo',
        name: 'getQrCodeInfo',
        component: () => import('../views/m9377/GetQrCodeInfo/GetQrCodeInfo.vue'),
    },
    {
        path: '/h5game',
        name: 'h5game',
        component: () => import('../views/m9377/h5game/h5game.vue'),
    },
    {
        path: '/appDownload',
        name: 'appDownload',
        component: () => import('../views/m9377/AppDownload/AppDownload.vue'),
    },
    {
        path: '/replyNews',
        name: 'replyNews',
        component: () => import('../views/m9377/ReplyNews/ReplyNews.vue'),
    },
    {
        path: '/likesNews',
        name: 'likesNews',
        component: () => import('../views/m9377/LikesNews/LikesNews.vue'),
    },
    {
        path: '/officialNewsDetail',
        name: 'officialNewsDetail',
        component: () => import('../views/m9377/OfficialNewsDetail/OfficialNewsDetail.vue'),
    },
    {
        path: '/cloudPurchaseList',
        name: 'cloudPurchaseList',
        component: () => import('../views/m9377/CloudPurchaseList/CloudPurchaseList.vue'),
    },
    {
        path: '/cloudPhoneManage',
        name: 'cloudPhoneManage',
        component: () => import('../views/m9377/CloudPhoneManage/CloudPhoneManage.vue'),
    },
    {
        path: '/superTopic',
        name: 'superTopic',
        component: () => import('../views/m9377/SuperTopic/SuperTopic.vue'),
    },
    {
        path: '/moreSuperTopic',
        name: 'moreSuperTopic',
        component: () => import('../views/m9377/MoreSuperTopic/MoreSuperTopic.vue'),
    },
    {
        path: '/searchPage',
        name: 'searchPage',
        component: () => import('../views/m9377/SearchPage/SearchPage.vue'),
    },
    {
        path: '/moreActivity',
        name: 'moreActivity',
        component: () => import('../views/m9377/MoreActivity/MoreActivity.vue'),
    },
    // sdk页面
    {
        path: '/sdkindex',
        name: 'sdkindex',
        component: () => import('../views/m9377/sdk/index/index.vue'),
        meta: {
            title: "",
        }
    },
    {
        path: '/sdksetting',
        name: 'sdksetting',
        component: () => import('../views/m9377/sdk/setting/setting.vue'),
        meta: {
            title: "设置",
        }
    },
    {
        path: '/sdkchangepassword',
        name: 'sdkchangepassword',
        component: () => import('../views/m9377/sdk/changepassword/changepassword.vue'),
        meta: {
            title: "修改密码",
        }
    },
    {
        path: '/sdkfocuswechat',
        name: 'sdkfocuswechat',
        component: () => import('../views/m9377/sdk/focuswechat/focuswechat.vue'),
        meta: {
            title: "关注公众号",
        }
    },
    {
        path: '/sdksharegame',
        name: 'sdksharegame',
        component: () => import('../views/m9377/sdk/sharegame/sharegame.vue'),
        meta: {
            title: "分享游戏",
        }
    },
    {
        path: '/sdkgift',
        name: 'sdkgift',
        component: () => import('../views/m9377/sdk/gift/gift.vue'),
        meta: {
            title: "礼包",
        }
    },
    {
        path: '/sdkrealname',
        name: 'sdkrealname',
        component: () => import('../views/m9377/sdk/realname/realname.vue'),
        meta: {
            title: "实名认证",
        }
    },
    {
        path: '/sdkbindphone',
        name: 'sdkbindphone',
        component: () => import('../views/m9377/sdk/bindphone/bindphone.vue'),
        meta: {
            title: "",
        }
    },
    {
        path: '/sdkresetpassword',
        name: 'sdkresetpassword',
        component: () => import('../views/m9377/sdk/resetpassword/resetpassword.vue'),
        meta: {
            title: "重置密码",
        }
    },
    {
        path: '/sdksecurityquestion',
        name: 'sdksecurityquestion',
        component: () => import('../views/m9377/sdk/securityquestion/securityquestion.vue'),
        meta: {
            title: "",
        }
    },
    {
        path: '/sdkdeleteaccount',
        name: 'sdkdeleteaccount',
        component: () => import('../views/m9377/sdk/deleteaccount/deleteaccount.vue'),
        meta: {
            title: "账号注销",
        }
    },
    {
        path: '/sdkuseragreement',
        name: 'sdkuseragreement',
        component: () => import('../views/m9377/sdk/useragreement/useragreement.vue'),
        meta: {
            title: "用户协议",
        }
    },
    {
        path: '/sdkprivacypolicy',
        name: 'sdkprivacypolicy',
        component: () => import('../views/m9377/sdk/privacypolicy/privacypolicy.vue'),
        meta: {
            title: "隐私条款",
        }
    },
];

export default routes;
